import React,{useEffect} from 'react';
import './styles/index.sass';
import './App.sass';

import logo_svg from './images/logo.svg'

import {
  BrowserRouter as Router,
} from "react-router-dom";


import {Slides} from './components/Slides';

function App() {

  const applyInnerHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }


  useEffect(()=>{
    //window.scrollTo(0,1);
    applyInnerHeight();
    window.addEventListener('resize',()=>{
      applyInnerHeight();
    })
  },[]) 

  return (
    <Router>
    <div className="App">
      <div className="mark">
        <img src={ logo_svg } alt="" />
      </div>
    <Slides/>
    </div>
    </Router>
  );
}

export default App;
